$('#downloads-tabs-list a').click(function (e) {
    e.preventDefault()
    $(this).tab('show');
})

// Dropdown
// First Item Text
let text = $(".nav-tabs-mobile li:first a").data("text");

$(".t-dropdown .dropdown-text").text(text);

// Toogle dropdown
$(".t-dropdown").on("click", function () {
    if ($(this).hasClass("active")) {
        $(this).removeClass("active");
        $(".nav-tabs-mobile").slideUp(300);
    } else {
        $(this).addClass("active");
        $(".nav-tabs-mobile").slideDown(300);
    }
})

// Tabs Mobile
$(".nav-tabs-mobile a").on("click", function (){
    text = $(this).data("text");
    $(".t-dropdown .dropdown-text").text(text);
    $(".t-dropdown").removeClass("active");
    $(".nav-tabs-mobile").slideUp(300);
})

// Custom Scrollbar
$("#downloads-tab-content").overlayScrollbars({
    className: "os-theme-dark",
    resize: "none",
    scrollbars: {
        clickScrolling: true
    }
});
